/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';

import { OfficeStatus } from '@gh/builder-shared-data';
import {
  ROW_ACTIVE_CLASS,
  ROW_BLOCKED_CLASS,
  ROW_DEACTIVATED_CLASS,
  ROW_DELETED_CLASS,
  ROW_IN_DELETION_CLASS,
  ROW_NEW_CLASS,
} from '@gh/common-internal-shared';
import { TranslationService } from '@gh/core-mls';
import { buildDateTimeColumn, LayoutBasedGridDefinition } from '@gh/core-ui-grid';

import { OfficeListItem } from '../../resources/office-list-item.model';
import { DateTimeTypes } from '@gh/common-shared';

@Injectable()
export class OfficeListGridDefinition extends LayoutBasedGridDefinition {

  columnDefs = {
    renewalDate : {...buildDateTimeColumn(DateTimeTypes.ShortDate)},
    status: {
      valueGetter: (params: any) => params.node.data.isDataImport
        ? this.translationService.get('lbl_data_import') : params.node.data.status,
      cellClass: ({ data }: { data: OfficeListItem }) => {
        if (data.isDataImport) {
          return 'import-status';
        }
        switch (data.statusValue) {
          case OfficeStatus.Active:
            return ROW_ACTIVE_CLASS;
          case OfficeStatus.New:
            return ROW_NEW_CLASS;
          case OfficeStatus.Blocked:
            return ROW_BLOCKED_CLASS;
          case OfficeStatus.InDeletion:
            return ROW_IN_DELETION_CLASS;
          case OfficeStatus.Deactivated:
            return ROW_DEACTIVATED_CLASS;
          default:
            return '';
        }
        },
    },
  };

  options = {
    getRowClass: ({ data }: { data: OfficeListItem }) => {
      if (data.statusValue === OfficeStatus.Deactivated) {
        return ROW_DELETED_CLASS;
      }
      if (data.statusValue === OfficeStatus.InDeletion) {
        return ROW_IN_DELETION_CLASS;
      }
    },
    getRowNodeId: (data: OfficeListItem) => data.officeId,
  };

  constructor(private translationService: TranslationService) {
    super();
  }
}
